// @ts-nocheck
import { YStack, styled } from 'tamagui';

export const Container = styled(YStack, {
  width: '100%',
  // Matches SHEET_MAX in PageFrame so content sits square inside the frame.
  maxWidth: 1280,
  marginHorizontal: 'auto',
  paddingHorizontal: '$4',
});
